import React from 'react';
import PropTypes from 'prop-types';

import getCsrfToken from 'dpl/shared/utils/getCsrfToken';
import SmartImage from 'dpl/components/SmartImage';
import { sendAnalyticsEvent } from 'dpl/util/analytics';
import { ANALYTICS_EVENTS } from 'dpl/constants/analytics';

import googleSSOIcon from 'dpl/assets/google_sso_icon.svg';

function ContinueWithGoogleButton({ state, analytics }) {
  const buttonCta = 'Continue with Google';

  function handleGoogleClick() {
    sendAnalyticsEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      ...analytics,
      button_cta: buttonCta
    });
  }
  return (
    <form action={`/api/users/auth/google_oauth2?state=${state}`} method="post">
      <input
        type="hidden"
        name="authenticity_token"
        value={`${getCsrfToken()}`}
        autoComplete="off"
      />
      <button
        type="submit"
        className="button bg-white br1 b--gray-300 button--large center w-100 flex items-center justify-center"
        onClick={handleGoogleClick}
      >
        <SmartImage src={googleSSOIcon} wrapperOnlyClassName="" />
        <span className="pl4 font-16 fw-medium">{buttonCta}</span>
      </button>
    </form>
  );
}

ContinueWithGoogleButton.propTypes = {
  state: PropTypes.string.isRequired,
  analytics: PropTypes.shape({
    view: PropTypes.string
  }).isRequired
};

export default ContinueWithGoogleButton;
